<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12" class="text-center">
        <h4 style="text-align: center">14. PARTICIPACIONES</h4>
      </b-col>

      <br />

      <b-list-group sm="12">
        <b-list-group-item
          v-for="(item, index) in participacion.participacion"
          :key="index"
        >
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Participación</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col md="3">
                <b-form-group label="Tipo de relación: ">
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    v-model="item.tipoRelacion"
                    :options="tipoRelacion"
                    class="mb-3"
                    @change="cambiosParticipacion[index] = true"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Tipo de institución: ">
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    v-model="item.sector.clave"
                    :options="sectorPrivado"
                    class="mb-3"
                    text-field="valor"
                    value-field="clave"
                    @change="
                      (cambiosParticipacion[index] = true),
                        encuentraValorInstitucion(index)
                    "
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="1">
                <b-form-group>
                  <label for="Pais">País:</label>
                  <b-form-input
                    disabled
                    value="MX"
                    type="text"
                    placeholder="Ingrese..."
                    @change="cambiosParticipacion[index] = true"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Entidad Federativa:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="
                      (cambiosParticipacion[index] = true),
                        encuentraValorEstado(index)
                    "
                    v-model="item.ubicacion.entidadFederativa.clave"
                    :options="estados"
                    text-field="valor"
                    value-field="clave"
                  >
                    <template v-slot:first>
                      <option :value="null">Selecciona </option>
                    </template></b-form-select
                  >
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label for="nombreins"
                    >Nombre de la empresa, sociedad, asociación:</label
                  >
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    v-model="item.nombreEmpresaSociedadAsociacion"
                    type="text"
                    placeholder="Ingrese..."
                    @change="cambiosParticipacion[index] = true"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label for="RFC">RFC:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    v-model="item.rfc"
                    type="text"
                    placeholder="Ingrese..."
                    @change="cambiosParticipacion[index] = true"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <label>Tipo participación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="
                      (cambiosParticipacion[index] = true),
                        encuentraTipoParticipacion(index)
                    "
                    v-model="item.tipoParticipacion.clave"
                    :options="tipoParticipacion"
                    text-field="valor"
                    value-field="clave"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="3">
                <b-form-group>
                  <label>Porcentaje de participación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosParticipacion[index] = true"
                    v-model="item.porcentajeParticipacion"
                    :options="porcentaje"
                  >
                    <template v-slot:first>
                      <option :value="null">Selecciona </option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="8">
                <b-form-group label="Recibe Remuneracion:">
                  <b-form-radio-group
                  :disabled="status === 'Concluida'"
                    @change="
                      (cambiosParticipacion[index] = true),
                        (item.montoMensual.valor = 0)
                    "
                    v-model="item.recibeRemuneracion"
                  >
                    <b-form-radio :value="true">Si</b-form-radio>
                    <b-form-radio :value="false">No</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>

              <b-col md="5" v-if="item.recibeRemuneracion === true">
                <b-form-group>
                  <label for="montomen">Monto mensual:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                    v-model="item.montoMensual.valor"
                    type="text"
                    placeholder="Ingrese..."
                    @change="cambiosParticipacion[index] = true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2" v-if="item.recibeRemuneracion === true">
                <b-form-group>
                  <label for="moneda">Moneda:</label>
                  <b-form-input
                    v-model="item.montoMensual.moneda"
                    type="text"
                    value="MXN"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-row style="text-align: center">
              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  size="sm"
                  variant="primary"
                  @click="modificarParticipacion(item._id, index)"
                  :disabled="enviando"
                  >Guarda participación</b-button
                >
                <br />
                <p v-show="cambiosParticipacion[index]" class="error-text">
                  <i>No se han guardado los cambios</i>
                </p>
                <br />
              </b-col>
              <b-col>
                <b-button
                v-if="status !== 'Concluida'"
                  variant="danger"
                  size="sm"
                  @click="eliminarParticipacion(item._id, index)"
                  >Eliminar participación</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoElemento()"
          >Agregar elemento</b-button
        >
      </b-col>
    </b-row>

    <br />
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label for="aclara">ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            v-model="participacion.aclaracionesObservaciones"
            type="text"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarAclaraciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-show="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2">
        <b-button
        
          variant="secondary"
          @click="verSeccion(13)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
        
          class="pull-right"
          variant="secondary"
          @click="verSeccion(15)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  props: ["participacion", "status"],
  components: {
    Datetime,
    Loader
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      cambiosParticipacion: [],
      tipoRelacion: ["DECLARANTE", "PAREJA", "DEPENDIENTE_ECONOMICO"],

      porcentaje: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99",
        "100"
      ],

      tipoParticipacion: [
        { clave: "SCIO", valor: "SOCIO" },
        { clave: "ACCI", valor: "ACCIONISTA" },
        { clave: "COMI", valor: "COMISARIO" },
        { clave: "REPR", valor: "REPRESENTANTE" },
        { clave: "APOD", valor: "APODERADO" },
        { clave: "COLB", valor: "COLABORADOR" },
        { clave: "BENE", valor: "BENEFICIARIO" },
        { clave: "OTRO", valor: "OTROS" }
      ],

      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      sectorPrivado: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "AGRICULTURA" }
      ]
    };
  },
  methods: {
    //////////////////////////////////////////////////////////////////////////////////desiciones////////////////////////////////////////////////////////////////

    checaindex(index) {
      if (Number.isInteger(index)) {
        return this.cambiosParticipacion[index];
      }

      return false;
    },
    encuentraValorEstado(index) {
      let indice;
      indice = this.estados.findIndex(
        x =>
          x.clave ===
          this.participacion.participacion[index].ubicacion.entidadFederativa
            .clave
      );
      this.participacion.participacion[
        index
      ].ubicacion.entidadFederativa.valor = this.estados[indice].valor;
    },

    encuentraTipoParticipacion(index) {
      let indice;
      indice = this.tipoParticipacion.findIndex(
        x =>
          x.clave ===
          this.participacion.participacion[index].tipoParticipacion.clave
      );
      this.participacion.participacion[
        index
      ].tipoParticipacion.valor = this.tipoParticipacion[indice].valor;
    },

    encuentraValorInstitucion(index) {
      let indice;
      indice = this.sectorPrivado.findIndex(
        x => x.clave === this.participacion.participacion[index].sector.clave
      );
      this.participacion.participacion[index].sector.valor = this.sectorPrivado[
        indice
      ].valor;
    },

    modificarParticipacion(idParti, index) {
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/participaciones/" +
            this.$route.params.id +
            "/participacion/" +
            idParti,
          {
            tipoOperacion: "AGREGAR",
            tipoRelacion: this.participacion.participacion[index].tipoRelacion,
            sectorClave: this.participacion.participacion[index].sector.clave,
            sectorValor: this.participacion.participacion[index].sector.valor,
            nombreEmpresaSociedadAsociacion: this.participacion.participacion[
              index
            ].nombreEmpresaSociedadAsociacion,
            rfc: this.participacion.participacion[index].rfc,
            tipoParticipacionClave: this.participacion.participacion[index]
              .tipoParticipacion.clave,
            tipoParticipacionValor: this.participacion.participacion[index]
              .tipoParticipacion.valor,
            porcentajeParticipacion: this.participacion.participacion[index]
              .porcentajeParticipacion,
            recibeRemuneracion: this.participacion.participacion[index]
              .recibeRemuneracion,
            montoMensualValor: this.participacion.participacion[index]
              .montoMensual.valor,
            montoMensualMoneda: "MXN",
            ubicacionPais: "MX",
            entidadFederativaClave: this.participacion.participacion[index]
              .ubicacion.entidadFederativa.clave,
            entidadFederativaValor: this.participacion.participacion[index]
              .ubicacion.entidadFederativa.valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambiosParticipacion[index] = false;
          this.$forceUpdate();
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo editar la inversión."
          });
          this.enviando = false;
        });
    },

    eliminarParticipacion(idParti, index) {
      swal({
        text: "¿Está seguro en eliminar la participación?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/participaciones/" +
                this.$route.params.id +
                "/participacion/" +
                idParti,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
              
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
                this.participacion.participacion.splice(index, 1);
                this.cambiosParticipacion.splice(index, 1);
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },

    nuevoElemento() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/participaciones/" +
            this.$route.params.id +
            "/participacion",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.participacion.participacion.push(res.data.participacion);
            this.cambiosParticipacion.push(false);
          }
          this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo crear nuevo elemento."
          });
          this.enviando = false;
        });
    },
    /////////////////////////////////////////////////////////////aclarariones observacionales///////////////////////////////////////////////////////////////////////////////////
    actualizarAclaraciones() {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/participaciones/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.participacion
              .aclaracionesObservaciones,
            ninguno: ""
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////

    actualizarSeccion() {
      this.enviando = true;
      axios
        .put(
          this.httpURL + "/declaraciones/" + this.$route.params.id + "/15",
          { economico: this.economico },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    }
  },
  created() {
    
    if (this.participacion.participacion.length > 0) {
      this.participacion.participacion.forEach(Element => {
        this.cambiosParticipacion.push(false);
      });
    }
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
